
  export default {
    name: 'ConfirmModal',
    props: {
      showModal: {
        type: Boolean,
        required: true,
      },
      modalTitle: {
        type: String,
        required: true,
      },
      modalMessage: {
        type: String,
        required: true,
      },
      confirmButtonText: {
        type: String,
        default: null,
      },
      cancelButtonText: {
        type: String,
        default: null,
      },
    },
    computed: {
      /* Подписи кнопок: переданное значение важнее, иначе — перевод интерфейса.
         Пропс по умолчанию не может быть `$t(...)`: он вычисляется до i18n. */
      resolvedConfirmText() {
        return this.confirmButtonText || this.$t('interface.buttons.confirm')
      },
      resolvedCancelText() {
        return this.cancelButtonText || this.$t('interface.buttons.cancel')
      },
    },
  }
